import React from 'react';
import ProfileImage from './ProfileImage';

const CleroFoto = ({ fotoUrl, alt, defaultAvatar }) => (
  <ProfileImage
    src={fotoUrl}
    alt={alt}
    className="clero-card-photo-img"
    fallbackSrc={defaultAvatar}
  />
);

export default CleroFoto;
